import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AdminSidebar } from "@/components/admin/admin-shell";
import { useAuth } from "@/hooks/use-auth";
import { isAdmin } from "@/lib/admin";

export const Route = createFileRoute("/_authenticated/admin")({
  head: () => ({
    meta: [
      { title: "Admin panel — Albazar.az" },
      {
        name: "description",
        content: "Marketplace idarəetmə mərkəzi: elanlar, mağazalar, ödənişlər, şikayətlər.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Admin panel — Albazar.az" },
      { property: "og:description", content: "Albazar.az idarəetmə paneli." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: AdminLayout,
});

function AdminLayout() {
  const { user, loading } = useAuth();
  const adminQuery = useQuery({
    queryKey: ["is-admin", user?.id],
    queryFn: () => isAdmin(user!.id),
    enabled: Boolean(user?.id),
  });

  if (loading || adminQuery.isLoading) {
    return (
      <div className="container-x flex min-h-[50vh] items-center justify-center py-16">
        <Loader2 className="size-6 animate-spin text-primary" />
      </div>
    );
  }

  if (adminQuery.data !== true) {
    return (
      <div className="container-x py-20 text-center">
        <h1 className="text-2xl font-extrabold">Giriş qadağandır</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Bu bölmə yalnız admin hüququ olan istifadəçilər üçündür.
        </p>
        <Button asChild className="mt-6 rounded-full">
          <Link to="/">Ana səhifəyə qayıt</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="container-x py-8">
      <div className="flex flex-col gap-6 lg:flex-row">
        <AdminSidebar />
        <div className="min-w-0 flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
